import React, { useState } from 'react';
export function SecretSectionTeaser() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const SECRET_PASSWORD = 'LECTURACLARA2024'; // contraseña que darás a tus clientes
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === SECRET_PASSWORD) {
      setError('');
      window.location.href = '/seccion-secreta'; // redirige a la página secreta
    } else {
      setError('Contraseña incorrecta.');
    }
  };
  return <section id="zona-exclusiva" className="py-20 bg-[#0C0A09] text-center border-t border-[#3b3330]" data-id="element-247">
      <h2 className="text-3xl font-semibold tracking-wide text-[#CFA86A]" data-id="element-248">
        Sección Secreta de Acceso Privado
      </h2>

      <p className="max-w-xl mx-auto mt-4 text-sm opacity-80" data-id="element-249">
        Existe una parte de este programa que no está disponible para el
        público. Es un espacio privado diseñado para quienes realmente toman
        decisiones y no solo las piensan.
      </p>

      <p className="max-w-xl mx-auto mt-2 text-xs opacity-60" data-id="element-250">
        Si ya realizaste tu compra, ingresa la contraseña que recibiste para
        desbloquearla.
      </p>

      <form onSubmit={handleSubmit} className="mt-8 space-y-3 max-w-xs mx-auto" data-id="element-251">
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Escribe tu contraseña" className="w-full rounded-md bg-[#1b1f2e] border border-[#CFA86A] px-3 py-3 text-sm text-[#F7F5F2] placeholder-[#8f856e] focus:outline-none focus:ring-2 focus:ring-[#CFA86A]" data-id="element-252" />

        {error && <p className="text-xs text-red-400" data-id="element-253">{error}</p>}

        <button type="submit" className="w-full px-5 py-2 rounded-md bg-[#CFA86A] text-[#0C0F17] text-sm font-semibold tracking-wide hover:brightness-110 transition" data-id="element-254">
          Desbloquear Sección
        </button>

        <p className="text-[10px] mt-2 opacity-60 italic" data-id="element-255">
          Solo para clientes. Recibes la contraseña después de completar tu
          compra.
        </p>
      </form>
    </section>;
}